import {OeMbl} from "../../../../fms.core/OeMbl";
import _ from "lodash";
import {MblStatusViewModel, OceanMblStatusMap, OeContainerEvents} from "../../../../fms.core/MblStatusViewModel";
import {PimsContainer} from "../../../../fms.core/pims/PimsContainer";
import {PimsCntrEvent} from "../../../../fms.core/PimsCntrEvent";



export function prepareOeMblForView(mbl:OeMbl) {
  // Init milestone
  if(!mbl.milestone) {
    mbl.milestone = new MblStatusViewModel();
  }
  if(mbl.milestone.eventItemList.length > 0) {
    _.remove(mbl.milestone.eventItemList);
  }

  if(mbl.milestone.cntrItemList == null) mbl.milestone.cntrItemList = [];
  if(mbl.milestone.eventItemList == null) mbl.milestone.eventItemList = [];

  if (!mbl.milestone.cntrItemList || mbl.milestone.cntrItemList.length === 0) {
    AddPimsCntrEvent(mbl, new PimsContainer({ bookingId: mbl.pimsLinkId, cntrNo: mbl.mblNo }))
  }
  else {
    mbl.milestone.cntrItemList.forEach(x => {
      AddPimsCntrEvent(mbl, x)
    })
  }
}

function AddPimsCntrEvent(mbl:OeMbl, pimsContainer:PimsContainer){
  OeContainerEvents.forEach((enumEvent) => {
    // let seqNo = 0;
    const smitem = OceanMblStatusMap.get(enumEvent);
    if(!smitem) return;
    mbl.milestone?.eventItemList?.push(new PimsCntrEvent({
      pimsCntrId: pimsContainer.id,
      cntrNo: pimsContainer.cntrNo,
      pickupNo: pimsContainer.pickupNo,
      name: smitem.label,
      lastDate: _.get(pimsContainer, smitem.pimsCntrDate??''),
      locName: _.get(pimsContainer, smitem.pimsCntrLoc??''),
      seq: enumEvent,   //seqNo++,
      isVisible: true
    }));
  });
}